// First-run guided tour state, per browser. Shown once; dismissing (or engaging
// with the widget) marks it seen so it never nags again.

const STORAGE_KEY = "maua-feedback-tour-seen";

export function tourSeen(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === "1";
  } catch {
    // localStorage blocked (private mode / sandbox) — treat as seen so we don't
    // re-show on every load with no way to remember the dismissal.
    return true;
  }
}

export function markTourSeen(): void {
  try {
    localStorage.setItem(STORAGE_KEY, "1");
  } catch {
    /* ignore */
  }
}
